import { Typography, TypographyProps } from '@mui/material';

type IncPageSectionTitleProps = {
  title: string;
} & TypographyProps;

const IncPageSectionTitle = ({ title, ...props }: IncPageSectionTitleProps) => {
  return (
    <Typography variant="h4" data-testid="IncPageSectionTitle" {...props}>
      {title}
    </Typography>
  );
};

export default IncPageSectionTitle;
